export interface ButtonAtomProps {
  text?: string;
  leftIcon?: boolean;
  icon?: any;
  rightIcon?: boolean;
  type?: ButtonType;
  onClick?: (any) => void;
  disabled?: boolean;
  arrowDown?: boolean;
  hasArrow?: boolean;
}

export interface IconProps {
  arrowDown?: boolean;
  type?: ButtonType.ArrowButton | ButtonType.Audio;
}

export enum ButtonType {
  ArrowButton,
  Audio,
  RedButton,
  Link,
  MapActive,
  X,
  ChatButton,
  ArrowDownRed,
  ArrowDownDefault,
  DownloadButton,
  RedButtonWhiteIcon,
  BlackButton,
  ArrowDown,
  ManagementButton,
  CookieButton,
  
}
